import { atom, useAtom } from 'jotai';
import { useRequest } from 'ahooks';
import {
  getPresetTimeList,
  createPresetTime,
  deletePresetTime,
  editPresetTime,
} from '@knowledge/service/api/general/index';
import { useQuery } from '@tanstack/react-query';

const presetTimes = atom<Knowledge.PresetTimes>([]);

let listRefreshFn = () => {};

export const usePresetTimes = () => {
  const [state, setState] = useAtom(presetTimes);

  const { isLoading, refetch } = useQuery({
    queryKey: ['presetTimes'],
    queryFn: () => getPresetTimeList(),
    onSuccess: (data) => {
      setState(data);
    },
  });

  listRefreshFn = refetch;

  return {
    loading: isLoading,
    data: state,
  };
};

export const usePresetTimeMutate = () => {
  const { runAsync: createPT, loading: addLoading } = useRequest((data) => createPresetTime(data), {
    manual: true,
    onSuccess: () => {
      setTimeout(() => {
        listRefreshFn();
      });
    },
  });

  const { runAsync: editPT, loading: editLoading } = useRequest((data) => editPresetTime(data), {
    manual: true,
    onSuccess: () => {
      setTimeout(() => {
        listRefreshFn();
      });
    },
  });

  const { runAsync: deletePT, loading: deleteLoading } = useRequest(
    (id: number) => deletePresetTime(id),
    {
      manual: true,
      onSuccess: () => {
        setTimeout(() => {
          listRefreshFn();
        });
      },
    },
  );

  return {
    createPT,
    editPT,
    deletePT,
    loading: addLoading || editLoading || deleteLoading,
  };
};
